import { Form, Select,  Input, InputNumber } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { useState } from "react";
import Widget from "../../components/Widget";
import "./newPayment.css";
const Option = Select.Option;
const FormItem = Form.Item;
export default function NewPayment({ field, fields, remove }) {
  const [type, setType] = useState(1);
  const onChangeHandler = (value) => {
    setType(value);
  };
  return (
      <Widget
        extra={
          fields.length > 1 ? (
            <MinusCircleOutlined
              className="dynamic-delete-button"
              style={{ margin: "0 0" }}
              onClick={() => {
                remove(field.name);
              }}
            />
          ) : null
        }
        styleName={"box"}
      >
        <>
          <FormItem
            label="نوع دریافتی"
            key={field.key}
            required
            name={"payType"}
            labelAlign="right"
            style={{ width: "95%",textAlign:"right" }}
            wrapperCol={{ span: 2 }}
          >
            <Select
              optionFilterProp="children"
              onChange={onChangeHandler}
              defaultValue={1}
            >
              <Option key={1} value={1}>
                نقدی
              </Option>
              <Option key={2} value={2}>
                حواله
              </Option>
              <Option key={3} value={3}>
                چکی
              </Option>
            </Select>
          </FormItem>
        </>
        {type === 1 && (
          <>
            <FormItem
              label="مبلغ"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
              name={"amount"}
            >
              <InputNumber
                style={{ width: "97%" }}
                defaultValue={0}
              />
            </FormItem>
            <FormItem
              label="توضیحات"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              name={"details"}
            >
              <Input className="gx-w-100" />
            </FormItem>
          </>
        )}
        {type === 2 && (
          <>
            <FormItem
              label="حساب"
              key={field.key}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
              name={"chequeAccount"}
            >
              <Select
                className="gx-w-100"
                optionFilterProp="children"
                onChange={onChangeHandler}
                defaultValue={1}
              >
                <Option key={1} value={1}>
                  حساب 1
                </Option>
                <Option key={2} value={2}>
                  حساب 2
                </Option>
                <Option key={3} value={3}>
                  حساب 3
                </Option>
              </Select>
            </FormItem>
            <FormItem
              label="مبلغ"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
              name={"amount"}
            >
              <InputNumber
                style={{ width: "95%" }}
                defaultValue={0}
                formatter={(value) =>
                  ` ريال${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              />
            </FormItem>
            <FormItem
              label="توضیحات"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              name={"details"}
            >
              <Input className="gx-w-100" />
            </FormItem>
          </>
        )}
        {type === 3 && (
          <>
            <FormItem
              label="شماره حساب"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              name={"accountNumber"}
              required
            >
              <Input className="gx-w-100" />
            </FormItem>
            <FormItem
              label="شماره چک"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              name={"chequeNumber"}
              required
            >
              <Input className="gx-w-100" />
            </FormItem>
            <FormItem
              label="کد بانک"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              name={"BankNumber"}
              required
            >
              <Input className="gx-w-100" />
            </FormItem>
            <FormItem
              label="نام بانک"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              name={"BankName"}
              required
            >
              <Input className="gx-w-100" />
            </FormItem>
            <FormItem
              label="شعبه بانک"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              name={"banckBranch"}
              required
            >
              <Input className="gx-w-100" />
            </FormItem>
            <FormItem
              label="مبلغ"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
              name={"amount"}
            >
              <InputNumber
                style={{ width: "95%" }}
                defaultValue={0}
                formatter={(value) =>
                  ` ريال${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              />
            </FormItem>
            <FormItem
              label="توضیحات"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              name={"details"}
            >
              <Input className="gx-w-100" />
            </FormItem>
          </>
        )}
      </Widget>
  );
}
